import api from './api';

export interface CajaUsuario {
    codigoCaja: number;
    usuario: string;
    nombreUsuario?: string;
    nombreCaja?: string;
}

export interface CajaUsuarioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    codigoCaja?: number;
    usuario?: string;
}

export interface CajaUsuarioPagedResult {
    items: CajaUsuario[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const cajaUsuarioService = {
    getCajasUsuario: async (params: CajaUsuarioSearchParams): Promise<CajaUsuarioPagedResult> => {
        const response = await api.get<CajaUsuarioPagedResult>('/api/CajaXusuario', { params });
        return response.data;
    },

    getCajaUsuario: async (codigoCaja: number, usuario: string): Promise<CajaUsuario> => {
        const response = await api.get<CajaUsuario>(`/api/CajaXusuario/${codigoCaja}/${usuario}`);
        return response.data;
    },

    getCajasPorUsuario: async (usuario: string): Promise<CajaUsuario[]> => {
        const response = await api.get<CajaUsuario[]>(`/api/CajaXusuario/usuario/${usuario}`);
        return response.data;
    },

    getUsuariosPorCaja: async (codigoCaja: number): Promise<CajaUsuario[]> => {
        const response = await api.get<CajaUsuario[]>(`/api/CajaXusuario/caja/${codigoCaja}`);
        return response.data;
    },

    createCajaUsuario: async (cajaUsuario: CajaUsuario): Promise<CajaUsuario> => {
        const response = await api.post<CajaUsuario>('/api/CajaXusuario', cajaUsuario);
        return response.data;
    },

    updateCajaUsuario: async (codigoCaja: number, usuario: string, cajaUsuario: CajaUsuario): Promise<void> => {
        await api.put(`/api/CajaXusuario/${codigoCaja}/${usuario}`, cajaUsuario);
    },

    deleteCajaUsuario: async (codigoCaja: number, usuario: string): Promise<void> => {
        await api.delete(`/api/CajaXusuario/${codigoCaja}/${usuario}`);
    }
};

export default cajaUsuarioService;
